import {API_URL} from "../common/config";

const axios = require('axios');

const multipartFileInstance = axios.create({
    baseURL: API_URL,
    withCredentials: true
});

export default multipartFileInstance;